import React, { useEffect, useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import WOW from 'wow.js';
import 'animate.css';
import { Navbar, Nav, Container, Offcanvas } from 'react-bootstrap';
import { GrServices } from "react-icons/gr";

const NavBar = () => {
    const location = useLocation();

    useEffect(() => {
        new WOW({ live: false }).init();
    }, []);


    const [modalStateSM, setModalStateSM] = useState(false)
    const [modalState, setModalState] = useState(false)

    const isServiceActive = !["/", "/Who-We-Are", "/Careers", "/contact-us"].includes(location.pathname);

    return (

        <div className='contain-nav'>
            <Navbar expand="lg" className="custom-navbar">

                <Navbar.Brand as={Link} to="/">
                    <img src="/logo.png"
                        className="logo d-inline-block align-top img-fluid"
                        data-wow-duration="0.5s"
                        alt="Logo"
                    />
                </Navbar.Brand>

                {/* Desktop Nav */}
                {/* <div className="desktop-nav">
                    <Nav className="me-auto">
                        <Nav.Link as={Link} to="/" className={location.pathname === "/" ? "activeNav" : ""}>
                            HOME
                        </Nav.Link>
                        <Nav.Link as={Link} to="/Who-We-Are" className={location.pathname === "/Who-We-Are" ? "activeNav" : ""}>
                            ABOUT US
                        </Nav.Link>
                        <Nav.Link  onClick={() => setModalState(!modalState)} className={location.pathname === "/Services" ? "activeNav" : ""}>
                            OUR SERVICES
                        </Nav.Link>
                    </Nav>
                    <Nav>
                        <Nav.Link as={Link} to="/contact-us" className="link-rounded">
                            CONTACT US
                        </Nav.Link>
                    </Nav>
                </div>
                */}

                <Navbar.Toggle aria-controls="offcanvasNavbar" />
                <Navbar.Offcanvas
                    id="offcanvasNavbar"
                    aria-labelledby="offcanvasNavbarLabel"
                    placement="end" className="navToggle"
                    scroll={true}>

                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title id="offcanvasNavbarLabel">

                            <img src="/logo.png"
                                className="logo d-inline-block align-top img-fluid wow fadeInDown"
                                data-wow-duration="0.5s"
                                alt="Logo"
                            />
                        </Offcanvas.Title>
                    </Offcanvas.Header>

                    <Offcanvas.Body>
                        <Nav className="me-auto">
                            <Nav.Link as={Link} to="/" className={location.pathname === "/" ? "activeNav" : ""}>
                                HOME
                            </Nav.Link>
                            <Nav.Link as={Link} to="/Who-We-Are" className={location.pathname === "/Who-We-Are" ? "activeNav" : ""}>
                                WHO WE ARE
                            </Nav.Link>
                            <Nav.Link onClick={() => setModalState(!modalState)}
                                className={isServiceActive ? "activeNav" : ""} >
                                OUR SERVICES
                            </Nav.Link>
                            {modalState &&
                                <div className='nav-dropDown-sm'>

                                    <Link to="/mechanical-Works" className='navDropDownLink'>
                                        <GrServices className='icon' />
                                        <div>
                                            <h4>MECHANICAL WORKS</h4>
                                            <p>Maintenance and repair of mechanical systems and components.</p>
                                        </div>
                                    </Link>
                                    <Link to="/Metal-Fabrication" className='navDropDownLink'>
                                        <GrServices className='icon' />
                                        <div>
                                            <h4>Metal Fabrications</h4>
                                            <p>Custom metal fabrication solutions for industrial applications.</p>
                                        </div>
                                    </Link>
                                    <Link to="/Civil-Works" className='navDropDownLink'>
                                        <GrServices className='icon' />
                                        <div>
                                            <h4>Civil Works</h4>
                                            <p>Infrastructure development and maintenance services.</p>
                                        </div>
                                    </Link>
                                    <Link to="/HSE-Solutions-and-Consultancy" className='navDropDownLink'>
                                        <GrServices className='icon' />
                                        <div>
                                            <h4>hse solutions and consultancy</h4>
                                            <p>Ensuring workplace safety and environmental compliance</p>
                                        </div>
                                    </Link>
                                    <Link to="/General-Procurement" className='navDropDownLink'>
                                        <GrServices className='icon' />
                                        <div>
                                            <h4>General Procurement</h4>
                                            <p>Expert advisory services for strategic business growth.</p>
                                        </div>
                                    </Link>

                                </div>
                            }
                            <Nav.Link as={Link} to="/Careers"  className={(location.pathname === "/Careers") ? "activeNav" : ""}>
                                CAREERS
                            </Nav.Link>
                        </Nav>
                        <Nav>
                            <Nav.Link as={Link} to="/contact-us" className="link-rounded">
                            GET IN TOUCH
                            </Nav.Link>
                        </Nav>
                    </Offcanvas.Body>
                </Navbar.Offcanvas>
            </Navbar>


            {modalState &&
                <div className='nav-dropDown'>

                    <Link to="/Mechanical-Works" className='navDropDownLink'>
                        <GrServices className='icon' />
                        <div>
                            <h4>MECHANICAL WORKS</h4>
                            <p>Maintenance and repair of mechanical systems and components.</p>
                        </div>
                    </Link>
                    <Link to="/Metal-Fabrication" className='navDropDownLink'>
                        <GrServices className='icon' />
                        <div>
                            <h4>Metal Fabrications</h4>
                            <p>Custom metal fabrication solutions for industrial applications.</p>
                        </div>
                    </Link>
                    <Link to="/Civil-Works" className='navDropDownLink'>
                        <GrServices className='icon' />
                        <div>
                            <h4>Civil Works</h4>
                            <p>Infrastructure development and maintenance services.</p>
                        </div>
                    </Link>
                    <Link to="/HSE-Solutions-and-Consultancy" className='navDropDownLink'>
                        <GrServices className='icon' />
                        <div>
                            <h4>Hse Solutions and Consultancy</h4>
                            <p>Ensuring workplace safety and environmental compliance</p>
                        </div>
                    </Link>
                    <Link to="/General-Procurement" className='navDropDownLink'>
                        <GrServices className='icon' />
                        <div>
                            <h4>General Procurement</h4>
                            <p>Expert advisory services for strategic business growth.</p>
                        </div>
                    </Link>
                    {/* <div className='navDropDownLink'>
                        <GrServices className='icon' />
                        <div>
                            <h4>General Procurement</h4>
                            <p>Ensuring efficient project execution, and sourcing of materials</p>
                        </div>
                    </div> */}

                </div>

            }






        </div>
    );
};

export default NavBar;